import { Trash, TrendUp } from "@phosphor-icons/react";
import DayCard from "./DayCard";

export default function WeekCard({ wi, week, completions, exMap, onUpdateIntent, onRemoveWeek, canRemove, onUpdateDay, onToggleComplete, onReorder, onChangeExercise, onRemoveExercise, onOpenPicker, onProgressWeek, onShowExerciseInfo, onReplaceExercises, assessmentNotes }) {
  return (
    <div className="border border-border">
      <div className="flex flex-wrap justify-between items-center bg-card border-b border-border px-3 py-3 gap-2">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="font-display text-2xl font-black shrink-0">WEEK {week.week_index}</div>
          <input
            value={week.intent || ""}
            onChange={(e) => onUpdateIntent(wi, e.target.value)}
            placeholder="Intent (e.g. Volume)"
            className="bg-secondary border border-border px-2 py-1 text-sm focus:outline-none focus:border-volt min-w-0 flex-1"
            data-testid={`week-intent-${wi}`}
          />
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {onProgressWeek && (
            <button
              onClick={() => onProgressWeek(week.week_index)}
              className="border border-volt text-volt px-3 py-1 inline-flex items-center gap-1 text-xs uppercase tracking-widest hover:bg-volt hover:text-black transition-colors"
              title="Create next week with progressed weights/reps/distances"
              data-testid={`progress-week-${wi}`}
            >
              <TrendUp size={14} weight="bold" />
              <span className="hidden sm:inline">Progress Next Week</span>
              <span className="sm:hidden">Next Wk</span>
            </button>
          )}
          {canRemove && (
            <button onClick={() => onRemoveWeek(wi)} className="text-muted-foreground hover:text-destructive" data-testid={`remove-week-${wi}`}>
              <Trash size={16} weight="bold" />
            </button>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-px bg-border">
        {week.days.map((d, di) => {
          const isComplete = !!(completions || {})[`${week.week_index}-${d.day}`];
          return (
            <DayCard
              key={`day-${week.week_index}-${d.day}-${di}`}
              wi={wi} di={di} day={d} isComplete={isComplete} exMap={exMap}
              onToggleComplete={onToggleComplete}
              onUpdateDay={onUpdateDay}
              onReorder={onReorder}
              onChangeExercise={onChangeExercise}
              onRemoveExercise={onRemoveExercise}
              onOpenPicker={onOpenPicker}
              onShowExerciseInfo={onShowExerciseInfo}
              onReplaceExercises={onReplaceExercises}
              assessmentNotes={assessmentNotes}
            />
          );
        })}
      </div>
    </div>
  );
}
